<template>
  <div>
    <b-col cols="12" class="my-2" v-b-toggle="'collapse-' + index">
      <b-row class="category-container" @click="toggleOpen">
        <font-awesome-icon :icon="mainCategory.icon" class="category-icon" />
        <h3 class="title ml-2">
          {{ mainCategory.title }}
        </h3>

        <font-awesome-icon
          icon="fa-solid fa-chevron-right"
          :class="`chevron ${chevronIsOpen ? 'rotated' : ''} chevron-default`"
        />
      </b-row>
    </b-col>
    <b-row>
      <b-col>
        <b-collapse
          v-model="defaultIsCollapsed"
          v-for="subCategory in mainCategory.subCategories"
          :class="
            `subcategories-container my-2 ${
              selectedFundMapCategory &&
              selectedFundMapCategory.mainCategory.title == mainCategory.title &&
              selectedFundMapCategory.subCategory.title == subCategory.title &&
              !isCategoryMap
                ? 'selected-sub-category'
                : ''
            }`
          "
          v-bind:key="subCategory.id"
          v-bind:id="'collapse-' + index"
        >
          <b-col class="sub-category-item" @click="selectCategory({ mainCategory, subCategory })">
            {{ subCategory.title }}
          </b-col>
        </b-collapse>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'FundMapMainCategory',
  data: function() {
    return {
      chevronIsOpen: window.innerWidth <= 768 ? false : true,
      defaultIsCollapsed: window.innerWidth <= 768 ? false : true
    }
  },
  props: {
    mainCategory: {},
    index: Number,
    isCategoryMap: Boolean
  },
  computed: {
    ...mapGetters(['selectedFundMapCategory'])
  },
  methods: {
    selectCategory(categoryObj) {
      if (!this.isCategoryMap) {
        this.$store.dispatch('selectFundMapCategoryAction', categoryObj)
      }
    },
    toggleOpen() {
      this.chevronIsOpen = !this.chevronIsOpen
    }
  }
}
</script>

<style lang="scss" scoped>
.category-container {
  padding: 10px;
  align-items: center;
}
.selected-sub-category {
  background: #00903c !important;
  color: white !important;
}
.category-icon {
  font-size: 24px;
  color: #00903c;
  margin-right: 10px;
}

.subcategories-container {
  font-weight: 700;
  font-size: 24px;
  color: #00903c;
  border: 1px solid #b2bec3;
  border-radius: 8px;
  text-align: left;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    background-color: #cce9d8;
  }
}

.chevron-default {
  position: absolute;
  right: 0;
  color: #636e72;
  font-size: 24px;
}

.chevron {
  transition: all 0.3s;
}

.chevron.rotated {
  transform: rotate(90deg);
}

.sub-category-item {
  padding: 24px 18px;
  min-height: 64px;
  display: flex;
  align-items: center;
}
.title {
  color: #636e72;
  margin-top: 9px;
  font-weight: 700;
  font-size: 32px;
}

@media all and (max-width: 577px) {
  .title {
    font-size: 24px;
  }
}

@media all and (max-width: 391px) {
  .title {
    font-size: 20px;
  }
  .category-icon {
    font-size: 20px;
  }
}
</style>
